import { memo } from 'react';

import './styles.scss';

function StatusIndicator({ status }) {
  return <div className={`statusIndicator ${status}`} style={{ backgroundColor: status }}></div>;
}

export default memo(StatusIndicator);
